import React, { useEffect, useState } from "react";
import {
  CURRENCY_EURO,
  parseGradeOverall,
  titleize,
  parseRequestedService,
  parseCategoryName,
  parseAmount,
  parseEncasing,
  parseBrandName,
  isDefined,
  displayTranslations,
  fullName,
  parseLanguageAcronim,
  parseGameName,
  scrollHtmlElementIntoView,
  isInAClosingState,
  parseSubmissionListItemRejectionReason
} from "../../utils/utils";
import I18n from 'i18n.js.erb'
import LanguageFlag from "./LanguageFlag";
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import ExpansionIcon from "./ExpansionIcon";
import RarityIcon from "./RarityIcon";
import Paginator from "./Paginator";
import IconTooltip from "./IconTooltip";
import GradingCertificate from "./GradingCertificate";



export const ItemDetail = ({
  item,
  handleShowLargeImage,
  submissionList,
  setBlueprintImage2ShowLargeImage,
  setproductToShowGradingCertificate,
  setShowCertificate,
  isMiddleman,
  index,
  itemsCount
}) => {

  const blueprintImage = item.product?.blueprint_image;
  const blueprintImageNames = isDefined(blueprintImage) ? displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language) : null;
  const blueprintImageFullName = fullName(blueprintImage?.en_name, blueprintImage?.meta_name, blueprintImage?.language)
  const entity = isDefined(blueprintImage) ? 'submission_list_item' : 'supplementary_item';

  return (
    <div className={`row w-100 mx-0 d-flex animated-item-initial-state submission_list_item_detail 
                    ${index % 2 === 1 ? 'bg-super-light-gray' : ''}`} key={entity + '_' + entity.id}
    //  style={{ animation: `scale-up 0.5s ease-out ${0.100 * ((index + 1) % (itemsCount + 1))}s forwards` }}
    >
      <div className="col-3 col-sm-2 col-lg-1 p-2 d-flex justify-content-center align-items-center border-right-solid border-bottom-solid border-bottom-xl-none">
        {
          entity === 'submission_list_item' ?
            <ShowBlueprintImageFrontImage
              size={"thumb"}
              blueprintImage={blueprintImage}
              handleShowLargeImage={handleShowLargeImage}
              additionalClasses={item.is_graded_image ? (blueprintImage?.blueprint?.category?.name?.toLowerCase() === 'booster pack' ? "thumb-image-graded-booster-pack m-auto" : "thumb-image-graded-card m-auto") : ''}
            />
            :
            item.thumb_image_url ?
              <ShowBlueprintImageFrontImage
                size={"thumb"}
                blueprintImage={item}
                handleShowLargeImage={handleShowLargeImage}
                additionalClasses={"br-4px"}
              />
              :
              <img src={window.location.origin + `/images/placeholder/placeholder.svg`}
                alt=""
                height='100'
                width='70'
              />
        }
      </div>

      <div className="col-9 col-sm-10 col-md-4 col-xl-2 p-2 border-right-md-solid border-bottom-solid border-bottom-xl-none">
        <div>
          <span className="color-gray font-size-14px">
            {I18n.t('js.editSubmissionListPage.tableHeaderName').toUpperCase()}
          </span>
        </div>
        <div className="d-blok">
          {
            entity === 'submission_list_item' ?
              <React.Fragment>
                {
                  blueprintImageNames.length > 1 ?
                    <React.Fragment>
                      <p className="mt-1 mb-0 text-truncate">
                        <IconTooltip
                          tooltipContent={blueprintImageFullName}
                          customTxt={blueprintImageNames[0]}
                        />
                      </p>
                      <p className="mb-0 text-truncate">
                        <IconTooltip
                          tooltipContent={blueprintImageFullName}
                          customTxt={blueprintImageNames[1]}
                        />
                      </p>
                    </React.Fragment>
                    :
                    <p className="mt-1 mb-0 text-truncate">
                      <IconTooltip
                        tooltipContent={blueprintImageFullName}
                        customTxt={blueprintImageNames[0]}
                      />
                    </p>
                }
                <p className="mt-0">
                  {blueprintImage.collector_number}
                </p>

                <div className="d-flex align-items-center mb-0">
                  <IconTooltip
                    tooltipContent={parseLanguageAcronim(blueprintImage.language)}
                    customComponentToRender={
                      <LanguageFlag
                        language={blueprintImage.language}
                        maxHeight={'20px'}
                        cssClassList={'mb-0'}
                        displayRoundFlag={true}
                        containerCssClassList={''}
                      />
                    }
                  />

                  <div className="my-0 p-0 ml-3">
                    <IconTooltip
                      tooltipContent={fullName(blueprintImage.en_expansion_name, blueprintImage.expansion_name, blueprintImage.language)}
                      customComponentToRender={
                        <ExpansionIcon
                          icon_url={blueprintImage.expansion.icon_url}
                          width={"23px"}
                          cssClassList={'m-0'}
                        />
                      }
                    />
                  </div>

                  <div className="my-0 p-0 ml-3">
                    <IconTooltip
                      tooltipContent={titleize(blueprintImage.rarity)}
                      customComponentToRender={
                        <RarityIcon
                          icon_url={blueprintImage.rarity_logo_url}
                          width={'20px'}
                          cssClassList={'m-0'}
                        />
                      }
                    />
                  </div>
                </div>
              </React.Fragment>
              :
              <p className="mt-1 mb-0">
                {I18n.t('js.editSubmissionListPage.inClassification')}
              </p>
          }
        </div>
      </div>

      <div className="col-12 col-sm-9 col-md-4 col-xl-3 border-right-sm-solid border-bottom-solid border-bottom-xl-none d-flex flex-directions-column justify-content-between">
        <div className="row p-2">
          <div className="col-12 px-1">
            <div>
              <span className="color-gray font-size-14px">
                {I18n.t('js.editSubmissionListPage.tableHeaderDescription').toUpperCase()}
              </span>
            </div>
            <p className="mt-1 mb-0 text-truncate">
              <IconTooltip
                tooltipContent={item.comes_from_supplementary_item ? item.comes_from_supplementary_item : (item.description ? item.description : I18n.t("js.common.noneFemale"))}
                customTxt={item.comes_from_supplementary_item ? item.comes_from_supplementary_item : (item.description ? item.description : I18n.t("js.common.noneFemale"))}
              />
            </p>
          </div>
        </div>

        <div className="row border-top-solid">
          <div className="col-6 p-2 border-right-solid">
            <div>
              <span className="color-gray font-size-14px">
                {I18n.t('js.myCollectionEditPage.tableHeaderCategory').toUpperCase()}
              </span>
            </div>
            <p className="mt-1 mb-0">
              <IconTooltip
                tooltipContent={parseCategoryName(isDefined(blueprintImage) ? blueprintImage.blueprint.category.name : item.category_name)}
                customTxt={parseCategoryName(isDefined(blueprintImage) ? blueprintImage.blueprint.category.name : item.category_name)}
              />
            </p>
          </div>

          <div className="col-6 p-2">
            <div>
              <span className="color-gray font-size-14px">
                {I18n.t('js.myCollectionEditPage.tableHeaderGame').toUpperCase()}
              </span>
            </div>
            <p className="text-truncate mt-1 mb-0">
              {
                entity === 'submission_list_item' ?
                  <IconTooltip
                    tooltipContent={parseGameName(blueprintImage.game.name)}
                    customTxt={parseGameName(blueprintImage.game.name)}
                  />
                  :
                  <IconTooltip
                    tooltipContent={parseBrandName(item.brand_name)}
                    customTxt={parseBrandName(item.brand_name)}
                  />
              }
            </p>
          </div>
        </div>
      </div>

      <div className="col-6 col-sm-3 col-md-2 col-lg-3 col-xl-1 p-2 border-right-solid border-right-sm-none border-right-xl-solid border-bottom-solid border-bottom-xl-none">
        <div className="d-flex d-xl-none mb-1">
          <span className="color-gray font-size-14px">
            {I18n.t('js.editSubmissionListPage.tableHeaderRequestedService').toUpperCase()}
          </span>
        </div>

        <div className="m-0 p-0 text-truncate">
          <IconTooltip
            tooltipContent={item.requested_service ? parseRequestedService(item.requested_service) + (item.grading_lower_limit ? ' - ' + parseConditionalGradingService(item) : '') : ''}
            customComponentToRender={
              <React.Fragment>
                {item.requested_service ? parseRequestedService(item.requested_service) : ''}
                <ConditionalGradingService
                  item={item}
                  cssClassList={'mt-2 text-truncate'}
                />
              </React.Fragment>
            }
          />
        </div>
      </div>

      <div className="col-6 col-sm-4 col-md-3 col-xl-1 p-2 border-bottom-solid border-bottom-md-none border-right-sm-solid">
        <div className="d-flex d-xl-none mb-1">
          <span className="color-gray font-size-14px">
            {I18n.t('js.editSubmissionListPage.tableHeaderEncasing').toUpperCase()}
          </span>
        </div>

        <div className="m-0 p-0 text-truncate">
          <IconTooltip
            tooltipContent={parseEncasing(item.encasing, blueprintImage ? blueprintImage.blueprint.category.name : item.category_name) + (item.case_lower_limit ? ' - ' + parseConditionalSleeveEncasing(item) : '')}
            customComponentToRender={
              <React.Fragment>
                {parseEncasing(item.encasing, blueprintImage ? blueprintImage.blueprint.category.name : item.category_name)}
                <ConditionalSleeveEncasing
                  item={item}
                  cssClassList={'mt-2 text-truncate'}
                />
              </React.Fragment>
            }
          />
        </div>
      </div>

      <div className="col-6 col-sm-4 col-md-3 col-xl-1 p-2 border-bottom-solid border-bottom-md-none border-right-solid">
        <div className="d-flex d-xl-none mb-1">
          <span className="color-gray font-size-14px">
            {I18n.t('js.editSubmissionListPage.tableHeaderLabel').toUpperCase()}
          </span>
        </div>

        <LanguageFlag
          language={item.label_language}
          maxHeight={'20px'}
          cssClassList={'mb-0'}
          displayRoundFlag={true}
          displayLanTxt={true}
        />

        <p className="mt-3">
          {I18n.t(`js.editSubmissionListPage.webComponent.draft.labelTypeOption.${item.label_type}_compact`)}
        </p>
      </div>

      <div className="col-6 col-sm-4 col-md-3 col-xl-1 p-2 border-bottom-solid border-bottom-md-none border-right-md-solid">
        <div className="d-flex d-xl-none">
          <span className="color-gray font-size-14px">
            {I18n.t('js.editSubmissionListPage.tableHeaderPrice').toUpperCase()}
          </span>
        </div>
        <div className="mt-1 mb-0">
          <ItemPricing
            item={item}
            amountToRender={isMiddleman ? 'amount_vat_excluded' : 'customer_amount_vat_excluded'}
            showVatMessage={true}
          />
        </div>
      </div>

      <div className="col-12 col-md-3 col-xl-2 p-2">
        <div className="d-flex d-xl-none mb-1">
          <span className="color-gray font-size-14px">
            {I18n.t('js.editSubmissionListPage.tableHeaderState').toUpperCase()}
          </span>
        </div>

        {
          !isInAClosingState(submissionList) && !submissionList.show_gradings ?
            <p className="text-weight-700 mb-0">
              {
                submissionList.state === 'received' ?
                  <span>
                    {I18n.t('js.myCollectionEditPage.productStateReceived')}
                  </span>
                  :
                  ['in_progress'].includes(submissionList.state) ?
                    <span>
                      {isDefined(item.product?.blueprint_image) ? I18n.t('js.myCollectionEditPage.productStateGrading') : I18n.t('js.editSubmissionListPage.inClassification')}
                    </span>
                    :
                    <span>
                      &nbsp;
                    </span>
              }
            </p>
            :
            item.rejected !== null ?
              <React.Fragment>
                <p className="mb-0 text-weight-700 color-dark-orange">
                  {I18n.t('js.common.submissionListState.rejected')}
                </p>
                <p className="my-0">
                  {parseSubmissionListItemRejectionReason(item.rejected)}
                </p>
              </React.Fragment>
              :
              item.grading &&
              <div className="d-block">
                <p className="text-weight-700 text-aiBlue">
                  {I18n.t('js.common.submissionListState.graded')}
                </p>

                <div className="d-bloc justify-content-center text-center">
                  <h2 className="text-aiBlue mt-0 mb-3">
                    {parseGradeOverall(item.grading)}
                  </h2>

                  {
                    item.product.enable_grading_certificate &&
                    <div>
                      <button
                        type="button"
                        id={`aig-certificate_${item.id}`}
                        className="submission_list_download_label_button color-white border-none py-1"
                        onClick={(e) => {
                          e.stopPropagation()
                          setBlueprintImage2ShowLargeImage(blueprintImage)
                          setproductToShowGradingCertificate(item)
                          setShowCertificate(true)
                        }}
                      >
                        <i className="fas fa-award" />
                        {I18n.t('js.showCertificateModal.certificate')}
                      </button>
                    </div>
                  }
                </div>
              </div>
        }
      </div>
    </div>
  );
}


export const parseConditionalSleeveEncasing = (item) => {
  if (item.case_lower_limit)
    return I18n.t('js.editSubmissionListPage.webComponent.draft.sleeveIf') + ' ' + I18n.t('js.editSubmissionListPage.webComponent.draft.overallLessThenCompact') + item.case_lower_limit
  else
    return '';
}

export const ConditionalSleeveEncasing = ({
  item,
  cssClassList
}) => {

  return (
    item.case_lower_limit &&
    <p className={cssClassList ? cssClassList : "color-dark-orange text-wrap my-0 font-size-84perc"}>
      {parseConditionalSleeveEncasing(item)}
    </p>
  );
}


export const parseConditionalGradingService = (item, compact) => {
  if (item.grading_lower_limit)
    return I18n.t(`js.editSubmissionListPage.webComponent.draft.authenticateIf${compact ? 'Compact' : ''}`) + ' ' + I18n.t('js.editSubmissionListPage.webComponent.draft.overallLessThenCompact') + item.grading_lower_limit
  else
    return '';
}

export const ConditionalGradingService = ({
  item,
  cssClassList
}) => {

  return (
    item.grading_lower_limit &&
    <p className={cssClassList ? cssClassList : "color-dark-orange text-wrap my-0 font-size-84perc"}>
      {parseConditionalGradingService(item, true)}
    </p>
  );
}



export const ItemPricing = ({
  item,
  baseAmountToRender,
  amountToRender,
  showVatMessage
}) => {

  return (
    <React.Fragment>
      <div className="p-0 m-0">
        <p className="mb-0">
          {parseAmount(item[amountToRender], 2) + CURRENCY_EURO}
          {
            showVatMessage &&
            <React.Fragment>
              &nbsp;
              <span className="font-size-80perc">
                ({I18n.t(`js.editSubmissionListPage.webComponent.draft.vat${amountToRender.indexOf('vat_excluded') > -1 ? 'Ex' : 'In'}cluded`)})
              </span>
            </React.Fragment>
          }
        </p>

        {
          isDefined(item.fee) &&
          <p className="mb-0">
            <span
              className={`font-size-80perc color-dark-orange text-wrap mt-2`}>
              ({parseAmount(item[baseAmountToRender], 2)}{CURRENCY_EURO} + {item.fee}%&nbsp;<br />
              {I18n.t('js.editSubmissionListPage.onDeclaredValue')})
            </span>
          </p>
        }
      </div>
    </React.Fragment>
  );
}


const SubmissionListContent = ({
  submissionList,
  handleShowLargeImage,
  isMiddleman
}) => {

  const [items, setItems] = useState([...submissionList.submission_list_items, ...submissionList.supplementary_items])
  const [blueprintImage2ShowLargeImage, setBlueprintImage2ShowLargeImage] = useState(null);
  const [productToShowGradingCertificate, setproductToShowGradingCertificate] = useState(null);
  const [showCertificate, setShowCertificate] = useState(false);

  useEffect(() => {
    if (items?.length > 0)
      scrollHtmlElementIntoView(document, 'itemsTopList', true)
  }, [items]);


  return (
    <div className="m-auto mt-10px">
      {
        submissionList.items_count > 0 ?
          <div>
            <div className="row animated-item-initial-state d-none d-xl-flex bg-aig-gradient w-100 mx-0 align-items-center br-top-8px color-white"
            //  style={{ animation: `scale-up 0.5s ease-out ${0.100}s forwards` }}>
            >
              <div className="col-3 py-3 px-2 d-none d-xl-flex justify-content-center">
                {I18n.t('js.editSubmissionListPage.tableHeaderItem').toUpperCase()}
              </div>
              <div className="col-3 py-3 px-2 d-none d-xl-flex">
                {I18n.t('js.editSubmissionListPage.tableHeaderDetails').toUpperCase()}
              </div>
              <div className="col-1 py-3 px-2 d-none d-xl-flex">
                {I18n.t('js.editSubmissionListPage.tableHeaderRequestedService').toUpperCase()}
              </div>
              <div className="col-1 py-3 px-2 d-none d-xl-flex">
                {I18n.t('js.editSubmissionListPage.tableHeaderEncasing').toUpperCase()}
              </div>
              <div className="col-1 py-3 px-2 d-none d-xl-flex">
                {I18n.t('js.editSubmissionListPage.tableHeaderLabel').toUpperCase()}
              </div>
              <div className="col-1 py-3 px-2 d-none d-xl-flex">
                {I18n.t('js.editSubmissionListPage.tableHeaderPrice').toUpperCase()}
              </div>
              <div className="col-2 py-3 px-2 d-none d-xl-flex">
                {I18n.t('js.editSubmissionListPage.tableHeaderState').toUpperCase()}
              </div>
            </div>

            <div className="row d-flex d-xl-none justify-content-center align-items-center text-center text-aig-gradient mx-0 pb-4">
              <h2><b>{I18n.t('js.editSubmissionListPage.tableHeaderItemsList')}</b></h2>
            </div>

            <div className="w-100 m-0 p-0" id="itemsTopList" />

            {items.map((item, i) => {
              return (
                <ItemDetail
                  key={(isDefined(item.product?.blueprint_image) ? 'submission_list_item_' : 'supplementary_item_') + item.id}
                  item={{ ...item }}
                  handleShowLargeImage={handleShowLargeImage}
                  submissionList={submissionList}
                  setBlueprintImage2ShowLargeImage={setBlueprintImage2ShowLargeImage}
                  setproductToShowGradingCertificate={setproductToShowGradingCertificate}
                  setShowCertificate={setShowCertificate}
                  isMiddleman={isMiddleman}
                  index={i}
                  itemsCount={items.length}
                />
              )
            }
            )}

            <Paginator
              itemsCount={submissionList.items_count}
              items={[...submissionList.submission_list_items, ...submissionList.supplementary_items]}
              setItems={setItems}
            />
          </div>
          :
          <div className="d-flex justify-content-center mt-5 pt-5">
            <div className="d-flex align-items-center">
              <p className="text-center text--size-18px text-weight-500">{I18n.t('js.editSubmissionListPage.noCardInSubmissionList')}</p>
            </div>
          </div>
      }

      <GradingCertificate
        originalGradingCertificate={productToShowGradingCertificate ? productToShowGradingCertificate.grading : ''}
        originalBlueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
        showCertificate={showCertificate}
        setShowCertificate={setShowCertificate}
      />
    </div>
  );
};

export default SubmissionListContent;